import { render, staticRenderFns } from "./directional-pad.vue?vue&type=template&id=67a273f4&scoped=true&"
import script from "./directional-pad.vue?vue&type=script&lang=js&"
export * from "./directional-pad.vue?vue&type=script&lang=js&"
import style0 from "./directional-pad.vue?vue&type=style&index=0&id=67a273f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a273f4",
  null
  
)

export default component.exports